/**
 * Утилиты для работы с часовыми поясами по регионам
 */

// Маппинг регионов на часовые пояса
const regionTimezones: Record<string, string> = {
  'Москва': 'Europe/Moscow',
  'Санкт-Петербург': 'Europe/Moscow',
  'Новосибирск': 'Asia/Novosibirsk',
  'Екатеринбург': 'Asia/Yekaterinburg',
  'Казань': 'Europe/Moscow',
  'Нижний Новгород': 'Europe/Moscow',
  'Челябинск': 'Asia/Yekaterinburg',
  'Самара': 'Europe/Samara',
  'Омск': 'Asia/Omsk',
  'Ростов-на-Дону': 'Europe/Moscow',
  'Уфа': 'Asia/Yekaterinburg',
  'Красноярск': 'Asia/Krasnoyarsk',
  'Воронеж': 'Europe/Moscow',
  'Пермь': 'Asia/Yekaterinburg',
  'Волгоград': 'Europe/Volgograd',
  'Краснодар': 'Europe/Moscow',
  'Саратов': 'Europe/Saratov',
  'Тюмень': 'Asia/Yekaterinburg',
  'Тольятти': 'Europe/Samara',
  'Ижевск': 'Europe/Samara',
  'Барнаул': 'Asia/Barnaul',
  'Ульяновск': 'Europe/Ulyanovsk',
  'Иркутск': 'Asia/Irkutsk',
  'Хабаровск': 'Asia/Vladivostok',
  'Ярославль': 'Europe/Moscow',
  'Владивосток': 'Asia/Vladivostok',
  'Махачкала': 'Europe/Moscow',
  'Томск': 'Asia/Tomsk',
  'Оренбург': 'Asia/Yekaterinburg',
  'Кемерово': 'Asia/Krasnoyarsk',
  'Новокузнецк': 'Asia/Krasnoyarsk',
  'Рязань': 'Europe/Moscow',
  'Астрахань': 'Europe/Astrakhan',
  'Набережные Челны': 'Europe/Moscow',
  'Пенза': 'Europe/Moscow',
  'Липецк': 'Europe/Moscow',
  'Киров': 'Europe/Kirov',
  'Чебоксары': 'Europe/Moscow',
  'Калининград': 'Europe/Kaliningrad',
  'Тула': 'Europe/Moscow',
  'Курск': 'Europe/Moscow',
  'Сочи': 'Europe/Moscow',
  'Ставрополь': 'Europe/Moscow',
  'Улан-Удэ': 'Asia/Irkutsk',
  'Магнитогорск': 'Asia/Yekaterinburg',
  'Тверь': 'Europe/Moscow',
  'Иваново': 'Europe/Moscow',
  'Брянск': 'Europe/Moscow',
  'Белгород': 'Europe/Moscow',
  'Сургут': 'Asia/Yekaterinburg',
  'Чита': 'Asia/Chita',
  'Владикавказ': 'Europe/Moscow',
  'Калуга': 'Europe/Moscow',
  'Смоленск': 'Europe/Moscow',
  'Волжский': 'Europe/Volgograd',
  'Череповец': 'Europe/Moscow',
  'Владимир': 'Europe/Moscow',
  'Саранск': 'Europe/Moscow',
  'Мурманск': 'Europe/Moscow',
  'Тамбов': 'Europe/Moscow',
  'Петрозаводск': 'Europe/Moscow',
  'Нижний Тагил': 'Asia/Yekaterinburg',
  'Кострома': 'Europe/Moscow',
  'Новороссийск': 'Europe/Moscow',
  'Йошкар-Ола': 'Europe/Moscow',
  'Таганрог': 'Europe/Moscow',
  'Сыктывкар': 'Europe/Moscow',
  'Нальчик': 'Europe/Moscow',
  'Шахты': 'Europe/Moscow',
  'Нижневартовск': 'Asia/Yekaterinburg',
  'Дзержинск': 'Europe/Moscow',
  'Братск': 'Asia/Irkutsk',
  'Орск': 'Asia/Yekaterinburg',
  'Ангарск': 'Asia/Irkutsk',
  'Благовещенск': 'Asia/Yakutsk',
  'Прокопьевск': 'Asia/Krasnoyarsk',
  'Бийск': 'Asia/Barnaul',
  'Энгельс': 'Europe/Saratov',
  'Химки': 'Europe/Moscow',
  'Псков': 'Europe/Moscow',
  'Балаково': 'Europe/Saratov',
  'Северодвинск': 'Europe/Moscow',
  'Армавир': 'Europe/Moscow',
  'Подольск': 'Europe/Moscow',
  'Королёв': 'Europe/Moscow',
  'Южно-Сахалинск': 'Asia/Sakhalin',
  'Мытищи': 'Europe/Moscow',
  'Норильск': 'Asia/Krasnoyarsk',
  'Комсомольск-на-Амуре': 'Asia/Vladivostok',
  'Петропавловск-Камчатский': 'Asia/Kamchatka',
  'Магадан': 'Asia/Magadan',
  'Якутск': 'Asia/Yakutsk',
};

/**
 * Получить часовой пояс для региона
 * @param region Название региона
 * @returns Название часового пояса (IANA timezone) или 'Europe/Moscow' по умолчанию
 */
export const getTimezoneByRegion = (region: string | null | undefined): string => {
  if (!region) {
    return 'Europe/Moscow'; // По умолчанию московское время
  }
  
  // Ищем точное совпадение
  if (regionTimezones[region]) {
    return regionTimezones[region];
  }
  
  // Ищем частичное совпадение (например, "Московская область" -> "Москва")
  const regionLower = region.toLowerCase();
  for (const [key, timezone] of Object.entries(regionTimezones)) {
    if (regionLower.includes(key.toLowerCase()) || key.toLowerCase().includes(regionLower)) {
      return timezone;
    }
  }
  
  // Если не найдено, возвращаем московское время по умолчанию
  return 'Europe/Moscow';
};
